import {
  AllIcon,
  ParkIcon,
  AirportIcon,
  LandmarkIcon,
  EducationIcon,
  HealthcareIcon,
  ShoppingCenterIcon,
} from "../assets";

export const locationFilterOptions = [
  {
    id: 1,
    name: "All",
    icon: AllIcon,
    type: 0,
  },
  {
    id: 2,
    name: "Healthcare",
    icon: HealthcareIcon,
    type: 1,
  },
  {
    id: 3,
    name: "Shopping Centers",
    icon: ShoppingCenterIcon,
    type: 2,
  },
  {
    id: 4,
    name: "Education",
    icon: EducationIcon,
    type: 3,
  },
  {
    id: 5,
    name: "Airport",
    icon: AirportIcon,
    type: 4,
  },
  {
    id: 6,
    name: "Landmarks",
    icon: LandmarkIcon,
    type: 5,
  },
  {
    id: 7,
    name: "Parks",
    icon: ParkIcon,
    type: 6,
  },
];
